// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page .p-inline-message-text {
  text-align: left;
}

.login-page .col,
.login-page [class*=col-] {
  padding: 0!important;
}

.login-page .fixed-row {
  height: 70px;
}`, "",{"version":3,"sources":["webpack://./src/ui/css/SetPasswordPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".login-page .p-inline-message-text {\n  text-align: left;\n}\n\n.login-page .col,\n.login-page [class*=col-] {\n  padding: 0!important;\n}\n\n.login-page .fixed-row {\n  height: 70px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
